import React from 'react';
import { SiBbc, SiCnn, SiTed } from 'react-icons/si';
import { FaUniversity, FaGlobe, FaNewspaper } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const MediaLogos = () => {
  const mediaLinks = [
    { name: "BBC English", icon: SiBbc, url: null, color: "text-white" },
    { name: "British Council", icon: FaUniversity, url: null, color: "text-blue-500" },
    { name: "CNN", icon: SiCnn, url: null, color: "text-red-600" },
    { name: "TED Education", icon: SiTed, url: null, color: "text-red-500" },
    { name: "Cambridge", icon: FaUniversity, url: null, color: "text-yellow-500" },
    { name: "Oxford Press", icon: FaNewspaper, url: null, color: "text-blue-400" },
    { name: "National Geographic", icon: FaGlobe, url: null, color: "text-yellow-400" },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto mt-16 px-4">
      {/* Milestone */}
      <div className="flex justify-center mb-12">
        <div className="group relative bg-gradient-to-r from-blue-600 to-blue-400 p-1 rounded-2xl transform hover:scale-105 transition-all duration-300 shadow-2xl shadow-blue-500/20">
          <div className="bg-black rounded-xl px-8 py-4 flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <div className="bg-blue-500 p-3 rounded-full animate-pulse">
              <SafeIcon icon={FaUniversity} className="text-4xl text-white" />
            </div>
            <div className="text-center md:text-left">
              <div className="text-blue-400 font-bold tracking-widest text-xs uppercase mb-1">Trusted By</div>
              <div className="text-3xl md:text-5xl font-black text-white">
                50,000+ <span className="text-blue-500 text-lg md:text-2xl font-bold">STUDENTS</span>
              </div>
            </div>
            <div className="hidden md:block h-12 w-px bg-blue-900"></div>
            <div className="text-gray-400 text-sm font-semibold">
              Global <br/> Community
            </div>
          </div>
        </div>
      </div>

      {/* As Seen On Grid */}
      <div className="border-t border-zinc-800 pt-8">
        <p className="text-center text-gray-500 text-sm font-bold uppercase tracking-widest mb-8">Curriculum Aligned With</p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 opacity-70 hover:opacity-100 transition-opacity duration-300">
          {mediaLinks.map((media, index) => (
            <div key={index} className="flex items-center gap-2 cursor-default" title={`Aligned with ${media.name}`}>
              <SafeIcon icon={media.icon} className={`text-2xl md:text-3xl ${media.color} grayscale hover:grayscale-0 transition-all`} />
              <span className="text-gray-500 font-bold text-sm md:text-base">{media.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MediaLogos;